module.exports = __webpack_public_path__ + "static/media/g.c8ff405c.JPG";